export default __webpack_public_path__ + "static/media/Kibawe.179d301b.png";